import {
  Route,
  Routes,
  useSectionHistoryTop,
  useHistoryCustomBack,
  useLocation,
} from 'weblite-router'
import { closeCurrentModal, ModalRenderer } from 'weblite-web-modal-viewer'
import { registeredModals } from '$comp/modals/modal.registration'
import { OVERLAY_PANEL_Z_INDEX_FACTOR } from './components/visibility-handler'

export function ModalViewerOverlay() {
  const location = useLocation()
  const sectionTop = useSectionHistoryTop('overlay')
  const isTop = sectionTop === 'modals'

  useHistoryCustomBack(() => {
    closeCurrentModal()
  }, [])

  // TODO[router]: Check why this component gets mounted when wapp overlay is open
  if (!location) return null

  return (
    <div
      style={{
        position: 'absolute',
        zIndex: isTop ? OVERLAY_PANEL_Z_INDEX_FACTOR : 0,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
      }}
    >
      <Routes>
        {Object.keys(registeredModals).map(cid => {
          return (
            <Route key={cid} name={cid} element={<ModalRenderer cid={cid} />} />
          )
        })}
      </Routes>
    </div>
  )
}
